import { useSelector } from "react-redux";
import HorizontalScrollList from "../../HorizontalScrollList";
import CategoryLinksList from "./CategoryLinksList";
import styles from "./CategoryHeaderLinks";
import { getCategorySeoLinks } from "../../../state/modules/category/selectors";

const CategoryHeaderLinks = () => {
  const { primarySeoLinks } = useSelector(getCategorySeoLinks);
  if (!primarySeoLinks.length) return null;

  return (
    <HorizontalScrollList
      scrollSnapping={false}
      className={styles.categoryHeaderLinks}
    >
      <CategoryLinksList links={primarySeoLinks} />
    </HorizontalScrollList>
  );
};

export default CategoryHeaderLinks;
